export default "__VITE_ASSET__cbe6a76a__"